module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_01@3x-7134bcfdd3f2f3b45dfcbc8eb6b016f8.webp";